import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class AllocBatchRerunService {

  constructor(private http: HttpClient) { }

  // ✅ CRITICAL: Service method signature following V6 pattern
  reRunAllocation(
    baseUrl: string,
    settings: any,
    data: any[],
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    
    const url = baseUrl + "/saveJsonObject?action_code=dc90p3";

    // ✅ CRITICAL: Build payload EXACTLY like original AngularJS
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Add the settings and data as CLOB objects (following original pattern)
    const jsonSettings = JSON.stringify(settings);
    const jsonObj = JSON.stringify(data);
    
    params = _.extend({ clob_settings: jsonSettings }, params);
    params = _.extend({ clob_data: jsonObj }, params);
    
    // Add required parameters from original service
    params.tax_year = filterParams.tax_year || settings.tax_year;
    params.scenario = filterParams.scenario || settings.scenario;
    params.jcd_key = globalService?.globalParams?.jcd_key || settings.jcd_key;
    params.sso_id = settings.sso_id;
    params.process_name = "Partnership Re-allocation Submission";

    // ✅ MUST use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        urlEncoded.set(key, params[key]);
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}
